var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('h2',[_vm._v("Telefones úteis")]),_c('p',[_vm._v(" Veja a lista de telefones úteis. ")])]),_c('b-col',{staticClass:"mt-0",attrs:{"cols":"12"}},[_c('list-telefone-util')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }